document.addEventListener('DOMContentLoaded', () => {
	const tocWrappers = document.querySelectorAll('.vb-toc-wrapper');

	tocWrappers.forEach((wrapper) => {
		const toggleButton = wrapper.querySelector('.vb-toc-toggle-button');
		const tocList = wrapper.querySelector('.vb-toc-list');
		const separator = wrapper.querySelector('.vb-toc-separator');

		if (!toggleButton || !tocList) return;

		const isEmpty = tocList.classList.contains('empty-toc');

		let isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
		const collapseLimit = parseInt(tocList.dataset.collapseLimit || '0');
		const allItems = tocList.querySelectorAll('.vb-toc-item');

		const activeIconHTML = toggleButton.dataset.activeIcon;
		const inactiveIconHTML = toggleButton.dataset.inactiveIcon;
		const activetextHTML = toggleButton.dataset.activetext;
		const inactivetextHTML = toggleButton.dataset.inactivetext;

		const updateView = () => {
			toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			toggleButton.innerHTML = isOpen
				? `${activetextHTML || ''}${activeIconHTML || ''}`
				: `${inactivetextHTML || ''}${inactiveIconHTML || ''}`;

			// ✅ Toggle vb-active class
			if (isOpen) {
				toggleButton.classList.add('vb-active');
			} else {
				toggleButton.classList.remove('vb-active');
			}

			// ✅ List display
			if (collapseLimit === 0 && !isOpen) {
				tocList.style.display = 'none';
			} else {
				tocList.style.display = 'grid';

				allItems.forEach((item, index) => {
					if (isOpen || index < collapseLimit) {
						item.style.display = 'list-item';
						item.setAttribute('aria-hidden', 'false');
						item.classList.remove('is-collapsed');
					} else {
						item.style.display = 'none';
						item.setAttribute('aria-hidden', 'true');
						item.classList.add('is-collapsed');
					}
				});
			}

			// ✅ Separator visibility
			if (separator) {
				const hasVisibleItems = isOpen || collapseLimit > 0;
				separator.style.display = hasVisibleItems ? 'block' : 'none';
			}
		};

		updateView();

		toggleButton.addEventListener('click', () => {
			isOpen = !isOpen;
			updateView();
		});
	});
});

document.addEventListener('click', function (e) {
	const target = e.target.closest('a.vb-toc-link[data-scroll]');
	if (!target) return;

	e.preventDefault();

	const hash = target.getAttribute('href');
	if (!hash || !hash.startsWith('#')) return;

	const targetEl = document.querySelector(hash);
	if (targetEl) {
		window.scrollTo({
			top: targetEl.getBoundingClientRect().top + window.pageYOffset - 60, // adjust -60 for offset
			behavior: 'smooth'
		});
	}
});
